import type { MessageExtractContent } from '@vivport/backend/types';

export type ExtractKind = MessageExtractContent['kind'];

export const KIND_CLASSES: Record<ExtractKind, string> = {
  DECISION: 'bg-kind-decision text-kind-decision-foreground border-kind-decision-border',
  QUESTION: 'bg-kind-question text-kind-question-foreground border-kind-question-border',
  ACTION: 'bg-kind-action text-kind-action-foreground border-kind-action-border',
  FAULT: 'bg-kind-fault text-kind-fault-foreground border-kind-fault-border',
  RISK: 'bg-kind-risk text-kind-risk-foreground border-kind-risk-border',
};
